module.exports = __webpack_public_path__ + "media/images/star-c07a5d2eae13c70094d4dead54e69f2c.svg";